export const SUGGEST_BUCKET_LIST_ITEM_Q = /* GraphQL */ `
  query SuggestBucketListItem {
    suggestBucketListItem {
      id
      label
      category
      description
      imageUrl
    }
  }
`;

export const RESPOND_BUCKET_LIST_ITEM_M = /* GraphQL */ `
  mutation RespondBucketListItem($itemId: ID!, $status: String!) {
    respondBucketListItem(itemId: $itemId, status: $status)
  }
`;

export const MY_BUCKET_LIST_Q = /* GraphQL */ `
  query MyBucketList {
    myBucketList {
      id
      label
      category
      description
      imageUrl
    }
  }
`;

export const REMOVE_BUCKET_LIST_ITEM_M = /* GraphQL */ `
  mutation RemoveBucketListItem($itemId: ID!) {
    removeBucketListItem(itemId: $itemId)
  }
`;

export const SUGGESTED_BUCKET_LIST_ITEMS_Q = /* GraphQL */ `
  query SuggestedBucketListItems($limit: Int) {
    suggestedBucketListItems(limit: $limit) {
      id
      label
      category
      description
      imageUrl
    }
  }
`;

export const BUCKET_LIST_ITEM_Q = /* GraphQL */ `
  query BucketListItem($id: ID!) {
    bucketListItem(id: $id) {
      id
      label
      category
      description
      imageUrl
    }
  }
`;
